// http is allowed alongside https so local development keeps working.
const ALLOWED_PROTOCOLS = ['http:', 'https:'];

// Resolve against the current origin; null unless the result is http(s).
export const safeUrl = url => {
  if (!url) return null;

  let parsed;
  try {
    parsed = new URL(url, window.location.origin);
  } catch (e) {
    return null;
  }

  return ALLOWED_PROTOCOLS.includes(parsed.protocol) ? parsed.toString() : null;
};

// Open in a new tab when the URL passes safeUrl. False if rejected.
export const openSafeUrl = url => {
  const target = safeUrl(url);
  if (!target) return false;

  window.open(target, '_blank', 'noopener,noreferrer');
  return true;
};

// Navigate the current tab when the URL passes safeUrl. False if rejected.
export const assignSafeUrl = url => {
  const target = safeUrl(url);
  if (!target) return false;

  window.location.href = target;
  return true;
};
